import { render, staticRenderFns } from "./AppClients.vue?vue&type=template&id=2f1b9998&scoped=true&"
import script from "./AppClients.vue?vue&type=script&lang=js&"
export * from "./AppClients.vue?vue&type=script&lang=js&"
import style0 from "./AppClients.vue?vue&type=style&index=0&id=2f1b9998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1b9998",
  null
  
)

export default component.exports